<div class="GroupList">
  <document-group-list
    *ngFor="let group of groups"
    [group]="group"
    [newIndicatorDays]="newIndicatorDays">
  </document-group-list>
</div>
